import { TemplateNotFound } from "../../components/icons/Icon2";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import {
  formatDateTime,
  getStatusColor,
  LastActionCell,
} from "../../Utils/Utils";
import styles from "./Orders.module.css";

const VoucherList = ({
  mode,
  voucherTab,
  headerData,
  loading,
  orderData,
  handleClick,
}) => {
  const voucherFields = {
    Order: [
      (d) => `${formatDateTime(d.orderDate)}`,
      "orderId",
      (d) => `${d.storeName}, ${d.city}`,
      "shippingType",
      "createdBy",
      "ordermanager",
      "orderType",
      "totalAmount",
      "status",
      (d) => <LastActionCell lastAction={d.lastAction} />,
    ],
    Purchase: [
      "voucherDate",
      "voucherNo",
      "supplierName",
      "warehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
    Adjustment: [
      "voucherDate",
      "voucherNo",
      "warehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
    Transfer: [
      "voucherDate",
      "voucherNo",
      "fromWarehouse",
      "toWarehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
  };

  const fields = voucherFields[voucherTab] || [];

  // console.log("order data ", orderData);

  return (
    <>
      <li
        className={`${styles.order_data_list_row_header} ${
          mode ? styles.order_data_list_row_header_dark : ""
        }`}
      >
        {headerData.map((h) => (
          <div className={styles.entry} key={h} title={h}>
            {h}
          </div>
        ))}
      </li>

      <div className={styles.order_data_list_container}>
        {loading ? (
          <div>
            <Skeleton
              lines={15}
              thickness={5}
              additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
            />
          </div>
        ) : (
          <>
            {orderData?.length === 0 ? (
              <div className={styles.no_data}>
                <NoDataFound
                  icon={<TemplateNotFound />}
                  textTitle={`No Data Found`}
                />
              </div>
            ) : (
              <>
                {orderData?.map((d, index) => (
                  <li
                    key={d.orderId || `order-${index}`}
                    className={`${styles.order_data_list_row} ${
                      mode ? styles.order_data_list_row_dark : ""
                    }
                      
                 
                    
                     ${
                       d.orderType === "Direct Collect"
                         ? styles.direct_collect
                         : d.orderType === "Master Order"
                           ? styles.master_order
                           : ""
                     }
                   
                    `}
                    onClick={() => {
                      handleClick(d);
                    }}
                  >
                    {fields.map((field, fieldIndex) => (
                      <div
                        key={`${d.orderId || index}-${fieldIndex}`}
                        className={styles.entry}
                        style={
                          field === "status" || field === "orderType"
                            ? {
                                color: getStatusColor(d[field]),
                                textTransform: "capitalize",
                              }
                            : {}
                        }
                        // title={
                        //   typeof field === "function" ? field(d) : d[field]
                        // }
                      >
                        {typeof field === "function" ? field(d) : d[field]}
                      </div>
                    ))}
                  </li>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default VoucherList;
